import React from 'react'
import BasketsDuplicatePage from './BasketsDuplicatePage'
import '../styles/index.scss'

function BasketsDuplicateContainer() {
    return (
        <div className='BasketsDuplicateContainer'>
            <BasketsDuplicatePage />
        </div>
    )
}

export default BasketsDuplicateContainer